export class Breadcrumb {
  label: string;
  url: string;
}


export enum BREADCRUMB_LABEL_VALUE {
  RECHERCHE = 'Recherche',
  VOLS = 'Vols',
  CONTENEURS = 'Conteneurs',
  CONTENANTS = 'Contenants',
  TRAJETS = 'Trajets',
  EXPEDITIONS = 'Expéditions'
}

